import { useMemo } from 'react';
import { FileActionsContextMenuPopper } from '@/components/Workspace.File/File.Actions.ContextMenu';
import { FileMenuItemsContext, type FileMenuItemsContextValue } from '@/containers/Workspace.File/Context';
import DownloadFileContainer from '@/containers/Workspace.File/DownloadFileContainer';
import { FileActionsContainer } from '@/containers/Workspace.File/FileMenuContainer';
import { assertCanImportTranscript, assertCanTranscribeFile } from '@/containers/Workspace.File/utils';
import type { IWorkspaceFileItem } from '@/types';

type Props = {
  data: IWorkspaceFileItem;
};

export const FileActionsContextMenu = ({ data }: Props) => {
  const menu: FileMenuItemsContextValue = useMemo(() => ({
    canChangeOwner: data.capabilities.canChangeOwner,
    canDelete: data.capabilities.canDelete,
    canDownload: data.capabilities.canDownload,
    canManageAccess: data.capabilities.canManageAccess,
    canMove: data.capabilities.canMove,
    canRename: data.capabilities.canRename,
    canTranscribe: assertCanTranscribeFile(data.transcript),
    canViewTranscript: !!data.transcript?.id,
    canImportTranscript: assertCanImportTranscript(data.transcript),
  }), [
    data.capabilities,
    data.transcript,
  ]);

  return (
    <DownloadFileContainer
      fileId={data.file.id}
      workspaceId={data.object.workspaceId}>
      <FileMenuItemsContext.Provider value={menu}>
        <FileActionsContainer
          file={data.file}
          object={data.object}
          transcriptId={data.transcript?.id ?? null}>
          <FileActionsContextMenuPopper />
        </FileActionsContainer>
      </FileMenuItemsContext.Provider>
    </DownloadFileContainer>
  );
};